(function () {
                if (window.flunnel_klaviyo_bridge) return; // double-init guard
                var SUBSCRIBE_PATH = '/apps/lp/subscribe';
                var ONSITE_PREFIX = '/onsite/js/';
                var ID_OK = /^[A-Za-z0-9_-]{1,64}$/;
                var done = {}; // lower-cased email -> 1, set once the email WAS identified
                var warned = false;

                // ---- consent: Shopify Customer Privacy API (16.22 pattern, fail closed)
                // 1 = allowed, 0 = refused / undecided, -1 = API not loaded.
                function consent() {
                  try {
                    var cp = window.Shopify && window.Shopify.customerPrivacy;
                    if (cp && typeof cp.marketingAllowed === 'function' && typeof cp.analyticsProcessingAllowed === 'function') {
                      return (cp.marketingAllowed() && cp.analyticsProcessingAllowed()) ? 1 : 0;
                    }
                  } catch (e) {}
                  return -1;
                }
                function consentState() {
                  var c = consent();
                  return c === 1 ? 'allowed' : (c === 0 ? 'denied' : 'unknown');
                }
                function loadConsentApi(cb) {
                  try {
                    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { cb(false); return; }
                    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { cb(!err); });
                  } catch (e) { cb(false); }
                }
                function withConsent(cb) {
                  var c = consent();
                  if (c === 1) { cb(true); return; }
                  if (c === 0) { cb(false); return; }
                  loadConsentApi(function (loaded) { cb(loaded && consent() === 1); });
                }

                // ---- klaviyo.js: what is already on the page, inject once, identify
                // through the official surface.
                // The company id an onsite script src carries: the path segment after
                // the prefix (canonical URL), else its company_id param (legacy URL).
                function scriptCompanyId(src) {
                  var i = src.indexOf(ONSITE_PREFIX);
                  if (i < 0) return null;
                  var seg = src.slice(i + ONSITE_PREFIX.length).split('/')[0].split('?')[0];
                  if (ID_OK.test(seg)) return seg;
                  var q = src.indexOf('company_id=');
                  if (q > -1) {
                    var v = src.slice(q + 11).split('&')[0].split('#')[0];
                    if (ID_OK.test(v)) return v;
                  }
                  return null;
                }
                // present: klaviyo.js (or its queue / object) is already on the page;
                // id: the company id it belongs to, null when it cannot be read.
                function onsiteState() {
                  var scripts = document.getElementsByTagName('script');
                  for (var i = 0; i < scripts.length; i++) {
                    var src = scripts[i].getAttribute('src') || '';
                    if (src.indexOf(ONSITE_PREFIX) > -1) return { present: true, id: scriptCompanyId(src) };
                  }
                  if (window.klaviyo || window._klOnsite) return { present: true, id: null };
                  return { present: false, id: null };
                }
                function inject(publicId) {
                  var s = document.createElement('script');
                  s.async = true;
                  s.src = 'https://static.klaviyo.com/onsite/js/' + publicId + '/klaviyo.js?company_id=' + publicId;
                  (document.head || document.documentElement).appendChild(s);
                }
                function identify(email) {
                  try {
                    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
                      window.klaviyo.identify({ email: email });
                      return;
                    }
                    window._klOnsite = window._klOnsite || [];
                    window._klOnsite.push(['identify', { email: email }]);
                  } catch (e) {}
                }
                function skip(reason) {
                  if (warned) return;
                  warned = true;
                  try { console.warn('[flunnel] Klaviyo identify skipped: ' + reason); } catch (e) {}
                }
                function identifyOnce(email, publicId) {
                  email = typeof email === 'string' ? email.trim() : '';
                  publicId = typeof publicId === 'string' ? publicId.trim() : '';
                  if (!email || !ID_OK.test(publicId)) return;
                  var key = email.toLowerCase();
                  if (done[key]) return;
                  withConsent(function (ok) {
                    if (!ok || done[key]) return; // refused, or the other input path got here first
                    var st = onsiteState();
                    if (st.present && st.id !== publicId) {
                      skip(st.id ? 'the onsite script on this page belongs to another Klaviyo account' : 'a Klaviyo object is present but its account cannot be read');
                      return;
                    }
                    if (!st.present) inject(publicId);
                    identify(email);
                    done[key] = 1;
                  });
                }

                // ---- the store's subscriber sentinel (task 65): a confirmed subscribe
                // marks this browser as known, before and regardless of the consent gate.
                function markSubscriber() {
                  try {
                    var fs = window.flunnelSubscriber;
                    if (fs && typeof fs.mark === 'function') fs.mark();
                  } catch (e) {}
                }

                // ---- input 1: the popup runtime's event (popup-system.md §8.4d)
                document.addEventListener('flunnel:klaviyo:identify', function (e) {
                  markSubscriber();
                  var d = e && e.detail;
                  if (d) identifyOnce(d.email, d.public_id);
                });

                // ---- input 2: pages published with the OLD runtime — read the
                // subscribe exchange itself. Scoped to the app-proxy path; the
                // caller gets the very same promise and an untouched Response.
                function isSubscribeUrl(url) {
                  try {
                    var path = new URL(String(url), location.href).pathname;
                    return path === SUBSCRIBE_PATH || path === SUBSCRIBE_PATH + '/';
                  } catch (e) { return false; }
                }
                function emailFrom(body) {
                  if (!body) return '';
                  try {
                    if (typeof body === 'string') {
                      var t = body.trim();
                      if (t.charAt(0) === '{') { var j = JSON.parse(t); return j && typeof j.email === 'string' ? j.email : ''; }
                      return new URLSearchParams(t).get('email') || '';
                    }
                    if (typeof body.get === 'function') { var v = body.get('email'); return typeof v === 'string' ? v : ''; }
                  } catch (e) {}
                  return '';
                }
                var nativeFetch = window.fetch;
                if (typeof nativeFetch === 'function') {
                  window.fetch = function (input, init) {
                    var p = nativeFetch.apply(window, arguments);
                    try {
                      var url = typeof input === 'string' ? input : (input && typeof input.url === 'string' ? input.url : String(input));
                      if (isSubscribeUrl(url) && p && typeof p.then === 'function') {
                        var email = emailFrom(init && init.body);
                        p.then(function (res) {
                          if (!res || !res.ok) return;
                          var copy;
                          try { copy = res.clone(); } catch (e) { return; }
                          copy.json().then(function (data) {
                            if (!data || !data.ok) return;
                            // Task 95: only a sign-up the server took marks; the bot check's quiet answer does not.
                            if (data.subscribed === true) markSubscriber();
                            if (email && data.identify && data.public_id) identifyOnce(email, data.public_id);
                          }, function () {});
                        }, function () {});
                      }
                    } catch (e) {}
                    return p;
                  };
                }

                window.flunnel_klaviyo_bridge = { identify: identifyOnce, consent: consentState };

                // Warm the Privacy API so the gate and the popup's consent field
                // can read a decision by the time a form is submitted.
                if (consent() === -1) loadConsentApi(function () {});
              })();